import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import checkExtensionInstalled from 'Helpers/Extension/CheckExtensionInstalled';

const messages = defineMessages({
  extension: {
    id: 'extension-install.extension',
    defaultMessage: 'Extension not installed',
  },
});

const extensionLink = 'https://chromewebstore.google.com/detail/fanatical-pc-game-price-c/fifbkhhgkgphkjjnjkgdfknbkkgapnca?utm_medium=referral&utm_source=fanatical.com&utm_campaign=AccountContactPreferences';


const ExtensionInstall = () => {
  const [assistantInstalled, setAssistantInstalled] = useState(false);
  const [isChrome, setIsChrome] = useState(false);
  const [isOpera, setIsOpera] = useState(false);

  const { formatMessage } = useIntl();

  useEffect(() => {
    // Check what browser the user is using
    if (window.chrome) setIsChrome(true);

    if (!!window.opr || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) setIsOpera(true);


    // Check if assistant is installed
    // Needs to be delayed because listener might not be set up yet.
    if (assistantInstalled) return;
    setTimeout(async () => {
      let isInstalled = false;

      try {
        await checkExtensionInstalled(true);
        isInstalled = true;
      } catch (e) {
        const errorMsg = formatMessage(messages.extension);
        console.warn(errorMsg); // eslint-disable-line no-console
      }

      if (isInstalled) setAssistantInstalled(true);
    }, 500);
  }, [assistantInstalled, formatMessage]);

  return (
    <div className="account-table-row">
      <div className="account-table-row-title">
        <FormattedMessage id="account.setting.title.assistant" defaultMessage="Fanatical PC Game Price Comparison Browser Extension" />
      </div>
      <div className="account-table-row-content">
        <div className="account-table-details-container">
          {assistantInstalled &&
            <span className="highlighted-text">
              <FormattedMessage id="account.setting.assistant.installed" defaultMessage="Installed" />
            </span>
          }
          {!assistantInstalled &&
            <FormattedMessage id="account.setting.assistant.not-installed" defaultMessage="Not Installed" />
          }
          {!assistantInstalled && (isChrome) && !isOpera &&
            <div className="account-table-details-smallprint">
              <FormattedMessage id="account.setting.assistant.smallprint" defaultMessage="Save time and money when you're shopping online for games." />&nbsp;
              <Link to="/browser-extension">
                <FormattedMessage id="account.setting.assistant.explanation.link" defaultMessage="Find out more." />
              </Link>
            </div>
          }
          {isOpera &&
            <div className="account-table-details-smallprint">
              <FormattedMessage
                id="account.extension.wedonthaveopera"
                defaultMessage="We don't have an Opera version yet, but you can try installing using this {operaAddOn} and most of the functionality we've tested works. Find out more about the browser extension {assistantLink}"
                values={{
                  operaAddOn: <a href="https://addons.opera.com/en/extensions/details/install-chrome-extensions/">
                    <FormattedMessage id="account.extension.operaaddon" defaultMessage="Opera add-on" />
                  </a>,
                  assistantLink: <Link to="/browser-extension">
                    <FormattedMessage id="account.extension.operaaddon.link" defaultMessage="here." />
                  </Link>,
                }}
              />
            </div>
          }
          {!isChrome && !isOpera &&
            <div className="account-table-details-smallprint">
              <FormattedMessage
                id="account.setting.assistant.availability"
                defaultMessage="The Fanatical browser extension is currently available for Chrome. We are looking into making it available for additonal browsers"
              />
            </div>
          }
        </div>
        {!assistantInstalled &&
          <div className="account-table-action-container">
            <a className="account-table-action-button" href={extensionLink} target="_blank" rel="noopener noreferrer" role="button">
              <FormattedMessage id="extension-install.install" defaultMessage="Install Browser Extension" />
            </a>
          </div>
        }
      </div>
    </div>
  );
};

export default connect(null, {})(ExtensionInstall);
